export default __webpack_public_path__ + "static/media/alert.49e4f0c9.svg";